import { render, staticRenderFns } from "./SummaryManagementEvaluations.vue?vue&type=template&id=7dda9840&scoped=true"
import script from "./SummaryManagementEvaluations.vue?vue&type=script&lang=js"
export * from "./SummaryManagementEvaluations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dda9840",
  null
  
)

export default component.exports